// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"9210e52e","339":"56013c5e","368":"6aae0710","488":"9ab3554e","538":"feb8f3d3","576":"4a97565f","687":"efa430b1","776":"8ec92f35","978":"69d82b6f"}[chunkId] + ".chunk.js";
};